import { useDispatch, useSelector } from "react-redux";
import { updateSecondStepGeneralsNestedFields } from "../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../redux/reducers/visibilityMatrixesReducer";
import GetValuesForSecondStepGeneralFields from "../../../../../../Utils/ClaimModelUpdateFunctions/GetValuesForSecondStepGeneralFields";
import { StoreType } from "../../../../../../redux/store/store";
import CountryAutocompleteField from "../../../../../../Components/CustomInputs/CountryAutocompleteField";

const CitizenshipField = () => {
   const dispatch = useDispatch();
   const fieldNameLowerCase = "citizenship";
   const fieldNameUpperCase = "Citizenship";
   const { fieldValue, visibilityMatrixes, claimFieldErrorsMessages } =
      GetValuesForSecondStepGeneralFields(fieldNameLowerCase);
   const isForeigner = useSelector(
      (state: StoreType) => state.claimState.personModel.isForeigner
   );

   return (
      <CountryAutocompleteField
         labelText="Státní příslušnost (stát)"
         placeholderText="Uveďte vaši státní příslušnosti"
         value={fieldValue as string | null}
         validationText={handleShowErrorMessage(
            fieldNameUpperCase,
            claimFieldErrorsMessages
         )}
         dependencyValue={
            shouldRenderSpecField(
               "GeneralFields",
               fieldNameUpperCase,
               visibilityMatrixes
            ) && Boolean(isForeigner)
         }
         fieldNameForScroll={fieldNameUpperCase}
         onChange={(value) =>
            dispatch(
               updateSecondStepGeneralsNestedFields({
                  value,
                  field: fieldNameLowerCase,
               })
            )
         }
      />
   );
};

export default CitizenshipField;
